/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Owner_2Inputs */

const en_mk_tb_example_owner_2 = /** @type {(inputs: Mk_Tb_Example_Owner_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner: backend developer`)
};

const id_mk_tb_example_owner_2 = /** @type {(inputs: Mk_Tb_Example_Owner_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanggung jawab: developer backend`)
};

/**
* | output |
* | --- |
* | "Owner: backend developer" |
*
* @param {Mk_Tb_Example_Owner_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_owner_2 = /** @type {((inputs?: Mk_Tb_Example_Owner_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Owner_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_owner_2(inputs)
	return en_mk_tb_example_owner_2(inputs)
});